import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationModalComponent implements OnInit {
    title = 'Confirmar acción';
    message = 'La siguiente acción no se puede deshacer. ¿Está seguro?';
    cancelButtonText = 'Cancelar';
    continueButtonText = 'Continuar';
    continueButtonStyle = 'success';
    messages;
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}
}
